import React from 'react';
import { Flex, Box, Text, Image } from 'rebass/styled-components';

import iconPhone from '../../assets/images/icon-phone.svg';
import iconBallot from '../../assets/images/icon-ballot.svg';
import iconHeartMonitor from '../../assets/images/icon-heart-monitor.svg';
import bubbleHowItWorks from '../../assets/images/bubble-how-it-works.svg';

const HowItWorks = () => (
  <Flex flexDirection="column" mx={[4, 5]} py={5}>
    <Text fontSize={'28px'} fontWeight="600" mt={2}>
      How it works
    </Text>
    <Box mt={4}>
      <Image src={iconPhone}></Image>
      <Text fontSize={1} fontWeight="600" fontFamily="lato" mt={2}>
        On your smartphone, download the LupusCorner Research app and enroll in
        the OASIS study
      </Text>
    </Box>
    <Box mt={4}>
      <Image src={iconBallot}></Image>
      <Text fontSize={1} fontWeight="600" fontFamily="lato" mt={2}>
        Complete weekly surveys on lupus flares and symptoms. Plus, share device
        data on activity and environmental factors
      </Text>
    </Box>
    <Box mt={4}>
      <Image src={iconHeartMonitor}></Image>
      <Text fontSize={1} fontWeight="600" fontFamily="lato" mt={2}>
        200 participants will receive a Withings Steel HR smartwatch. Setup the
        device to contribute sleep and activity data
      </Text>
    </Box>

    <Flex justifyContent="flex-end" flexWrap="wrap" width="100%">
      <Box mt={['-420px', '-380px']} mr={[-4, -5]}>
        <Image src={bubbleHowItWorks}></Image>
      </Box>
    </Flex>
  </Flex>
);

export default HowItWorks;
